var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<span>This is the invisible launcher window for OpenFin</span>\n<div ng-controller=\"LaunchController as vm\">\n<table id=\"messageTable\">\n<tr>\n<th>Messages</th>\n</tr>\n<tr ng-repeat=\"m in vm.messages\">\n<td>{{m.data}}</td>\n</tr>\n</table>\n</div>\n";
var id1="views/launch.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ../partials/views/launch.html
// module id = 142
// module chunks = 0